import actionTypes from 'dashboard/actions/license-renewal/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_LICENSE_RENEWAL_SUCCESS: {
      return [...action.data];
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/license-renewal/retailers.js